<template>
    <div class="flex items-center justify-between">
        <h5 v-if="TamanhoFonteLabel == 'H5'" class="text-lg font-semibold text-gray-900 dark:text-gray-100 m-0">
            {{ NomeLabel }}
        </h5>
        <h3 v-if="TamanhoFonteLabel == 'H3'" class="text-xl font-semibold text-gray-900 dark:text-gray-100 m-0">
            {{ NomeLabel }}
        </h3>
        
        <button 
            v-if="habilitarClick" 
            @click="abrirDisclaimer"
            class="flex items-center gap-1.5 px-2 py-1 text-xs font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
        >
            <span class="underline">saiba mais</span>
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
        </button>
    </div>

    <ModalInformativoDisclaimerVue />

</template>

<script>
import { mapGetters } from "vuex";

import ModalInformativoDisclaimerVue from '../views/Cadastro/Utilitarios/Disclaimer/ModalInformativoDisclaimer.vue'

export default {
    computed: {
        ...mapGetters({
            listaDisclaimer: "GET_LISTA_DISCLAIMER",
        }),
    },
    name: "LabelDisclaimer",
    props: ["TamanhoFonteLabel","NomeLabel", "TipoCliente", "Sessao", "SubSessao"],
    components: {ModalInformativoDisclaimerVue},
    data(){
        return {
            habilitarClick: false
        }
    },
    created(){
        var objDisclaimer = { Sessao: this.Sessao, SubSessao: this.SubSessao, TipoCliente: this.TipoCliente, Abrir: false};
        this.$store.commit('SET_MODAL_DISCLAIMER_INFORMATIVO', objDisclaimer);

          if(this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == objDisclaimer.TipoCliente && disclaimer.Secao == objDisclaimer.Sessao && disclaimer.SubSecao == objDisclaimer.SubSessao) != null){
                this.habilitarClick = true;
          }else{
                this.habilitarClick = false;
          }

    },
    methods: {
        abrirDisclaimer(){
            var objDisclaimer = { Sessao: this.Sessao, SubSessao: this.SubSessao, TipoCliente: this.TipoCliente, Abrir: true};
            this.$store.commit('SET_MODAL_DISCLAIMER_INFORMATIVO', objDisclaimer);
        }
    },
    watch: {
        objDisclaimer(){
          if(this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == this.objDisclaimer.TipoCliente && disclaimer.Secao == this.objDisclaimer.Sessao && disclaimer.SubSecao == this.objDisclaimer.SubSessao) != null){
                this.habilitarClick = true;
          }else{
                this.habilitarClick = false;
          }
        }
    }
}
</script>

<style scoped>
/* Estilos gerenciados pelo Tailwind */
</style>
